"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20017ToJSON = exports.InlineResponse20017FromJSONTyped = exports.InlineResponse20017FromJSON = void 0;
var _1 = require("./");
function InlineResponse20017FromJSON(json) {
    return InlineResponse20017FromJSONTyped(json, false);
}
exports.InlineResponse20017FromJSON = InlineResponse20017FromJSON;
function InlineResponse20017FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'chatMessages': (json['chatMessages'].map(_1.ChatMessageFromJSON)),
    };
}
exports.InlineResponse20017FromJSONTyped = InlineResponse20017FromJSONTyped;
function InlineResponse20017ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'chatMessages': (value.chatMessages.map(_1.ChatMessageToJSON)),
    };
}
exports.InlineResponse20017ToJSON = InlineResponse20017ToJSON;
